import Calendar from './Calendar.svelte';
const createCalendar = (target, { placeholder = '-', blank, selectedDate, startMonth, endMonth, selectInitialDate = false, onSelect, customWeekdayValues, customMonthValues }) => new Calendar({
    target: target,
    props: {
        onSelect,
        placeholder,
        blank,
        selectedDate: selectedDate || new Date,
        startMonth,
        endMonth,
        selectInitialDate,
        customWeekdayValues,
        customMonthValues
        // customWeekdayValues: new Array(7).fill(0).map((_, i) => i + 1 + ''),
        // customMonthValues: new Array(12).fill(0).map((_, i) => i + 1 + '')
    }
});
export default createCalendar;
